// TODO: Get rid of this file

import { useQuery } from '@tanstack/react-query';
import { getPropertyTenancy } from '../../active-notice/service';

function useTenancyDetails(propertyId: number) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'tenancy-old'],
        queryFn: () => getPropertyTenancy(propertyId),
    });

    return query;
}

export { useTenancyDetails };
